import {
  formatTimegridAppointmentTime,
  minutesToThreeDigitsTime,
  timeToMinutes,
} from 'Data/format.js'

export function getAppointmentBookingTime(appointment_booking) {
  let local_end_time = minutesToThreeDigitsTime(
    timeToMinutes(appointment_booking.local_start_time) +
      appointment_booking.duration
  )

  let start = `${appointment_booking.local_start_date}T${appointment_booking.local_start_time}`
  let end = `${appointment_booking.local_start_date}T${local_end_time}`
  return formatTimegridAppointmentTime({ start, end })
}
